import React, { useState } from "react";

import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import logoLocal from "../../assets/caê.png";
import ThemeToggle from "../Theme/theme";

function Topbar({ siteContent }) {
  const { page: pages } = siteContent;
  const logo = siteContent?.logo?.url
  const [open, setOpen] = useState(false);

  const sorted = [...pages].sort((a, b) =>
    a.title.localeCompare(b.title, 'pt-BR', { sensitivity: 'base' })
  );

  return (
    <>
      <header className="topbar">
        <div className="container topbar__inner">
          <NavLink className="brand" to="/" exact onClick={() => setOpen(false)}>
            <img alt="Logo Caê" src={logo || logoLocal} className="brand__icon" aria-hidden="true" />
          </NavLink>

          <nav className="nav" aria-label="Navegação principal">
            {sorted && sorted.map(page => (
              <NavLink key={page?.slug} className="nav__link" to={`/${page?.slug}`} activeClassName="isActive">
                {page?.title.toUpperCase()}
              </NavLink>
            ))}
            <ThemeToggle />
          </nav>

          <div className="container__menu">
            <ThemeToggle />
            <button className="burger" onClick={() => setOpen((v) => !v)} aria-label="Abrir menu">
              <span className="burger__bar" />
              <span className="burger__bar" />
              <span className="burger__bar" />
            </button>
          </div>
        </div>
      </header>

      <div className={`drawer ${open ? "isOpen" : ""}`}>
        <div className="drawer__panel">
          <div className="drawer__head">
            <span className="drawer__title">Menu</span>
            <button className="drawer__close" onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="drawer__links">
            {sorted && sorted.map(page => (
              <NavLink key={page?.slug} className="drawer__link" to={`/${page?.slug}`} activeClassName="isActive" onClick={() => setOpen(false)}>
                {page?.title.toUpperCase()}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Topbar;